
export default {
  title: 'Contact Us',
  message: 'Message',
  submit: 'Submit',
  contact: 'Contact',
  contactSuccessTitle: 'Thank you for getting in touch!',
  contactSuccessMessage: 'Our service executive will get back to you shortly.',
}
